import React, {useRef} from "react";
import {FieldInlineEditableProps} from "../../../render/inline-editable";
import Attachment from "../../../../model2/attachment/attachment";
import AttachmentsManager from "../../../../gd-components/files/attachments-manager/attachments-manager";
import AttachmentsCollection from "../../../../model2/attachment/attachments";
import {AttachFileMode} from "../../../../gd-components/files/const";
import ButtonAddAttachmentLink from "../../../../gd-components/files/add-attachment-button/add-link";

export default function FieldAttachments_InlineEditable(props: FieldInlineEditableProps) {

    const attachmentsRef = useRef<any>(null);
    const attachments: Attachment[] = props.model[props.field.fieldId]

    const onSelect = (dataFrom: "local" | "google-drive")=>{
        attachmentsRef.current.selectAttachment(dataFrom)
    }

    const onChange = (value: AttachmentsCollection)=>{
        props.onChange && props.onChange(value)
    }

    return(
        <div className="attachments-container flex-column-left-center">
           <AttachmentsManager  ref={attachmentsRef}
                                mode={AttachFileMode.VIEW_AND_EDIT}
                                className="m-l-10 m-t-15"
                                attachmentsCollection={new AttachmentsCollection(attachments)}
                                dropzoneDOMElementId={props.configOptions.dropzoneDOMElementId || "ui-page"}
                                onChange={onChange} />
            <div className="flex-row-left-center">
                <ButtonAddAttachmentLink onSelect={onSelect} className="m-l-10"/>
            </div>
        </div>
    )
}
